const cloudcheckGoQuicksend = (customerName, sendingChannel, value) => {
  const data = {
    reference: "Go quick send reference 101",
    givenName: customerName,
    generateLink: false,
    // emailAddress or mobileNumber
    [sendingChannel]: value,
    requestType: {
      verification: true,
      live: false,
      idscan: true,
      akahu: false,
      credfin: false,
    },
  };
  return data;
};

module.exports = { cloudcheckGoQuicksend };

// const cloudcheckGoQuicksend = () =>{
//   const data = {
//     reference: "Go quick send reference 101",
//     givenName: "Donald",
//     generateLink: false,
//     emailAddress: "noreply@verifidentity.com",
//     mobileNumber: "+64221234567",
//     completeUrl: "https://www.mycompany.com/id-complete?id=1234",
//     notificationUrl: "https://www.mycompany.com/notify-me",
//     requestType: {
//         verification: true,
//         live: false,
//         idscan: true,
//         akahu: false,
//         credfin: false
//     }
//     }
// }
